import {makeAutoObservable} from "mobx";
export default class SidebarWidgetStore {

    openSidebarWidget = true;

    constructor() {
        makeAutoObservable(this);
    }

    handleOpenSidebarWidget(){
        this.openSidebarWidget = true;
    }

    handleCloseSidebarWidget(){
        this.openSidebarWidget = false;
    }

}